class UpdateRootVars {
  constructor() {
    this.initialize()
    this.updateViewportHeight()
    this.updateViewportWidth()
    if (document.querySelector('.js-player') != null) {
      this.updatePlayerHeight()
    }
  }

  initialize() {
    this.bindEvents()
  }

  bindEvents() {
    window.addEventListener('resize', this.updateViewportHeight);
    window.addEventListener('resize', this.updateViewportWidth);
    if (document.querySelector('.js-player') != null) {
      window.addEventListener('resize', this.updatePlayerHeight);
    }
  }

  updateViewportHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);  
  }

  updateViewportWidth() {
    document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth}px`);  
  }
  
  updatePlayerHeight() {
    document.documentElement.style.setProperty('--player-height', `${document.querySelector('.js-player').offsetHeight}px`);  
  }
}

export default UpdateRootVars
